import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

class SOServices {
  createSO = async (payload) => {
    const so = await Helpers.post({
      url: Constants.SO,
      data: payload,
    });
    return so;
  }

  updateSO = async (payload) => {
    const so = await Helpers.put({
      url: Constants.SO,
      data: payload,
    });
    return so;
  }

  updateSOStatus = async (payload) => {
    const po = await Helpers.put({
      url: Constants.SO_STATUS,
      data: payload,
    });
    return po;
  }

  updateBundleLines = async (payload) => {
    const bundle = await Helpers.put({
      url: Constants.UPDATE_BUNDLE,
      data: payload,
    });
    return bundle;
  }

  deleteBundleLines = async (payload) => {
    const bundle = await Helpers.delete({
      url: Constants.DELETE_BUNDLE_LINE,
      data: payload,
    });
    return bundle;
  }

  updateSOWorkflowStep = async (payload) => {
    const po = await Helpers.post({
      url: Constants.SO_WORKFLOW,
      data: payload,
    });
    return po;
  }

  deleteSO = async (payload) => {
    const po = await Helpers.delete({
      url: Constants.SO,
      data: payload,
    });
    return po;
  }

  getSO = async (orgId, tenantId, orderId, status, customerId, page, limit, searchKeyword, fulfillmentStatus, startDate, endDate, departmentId, listScreen, paymentStatus, secondaryStatus, shopifySearchKeyword, tags, accountManagerIds, fromDeliveryDate, toDeliveryDate, fromOrderDate, toOrderDate, isLinkedMrp, orderType, excludeOrderIds, excludeGRNCustomerIds, productSkuIds, sourceTenantId) => {
    let url = `${Constants.SO}?`;
    if (orgId) url += `org_id=${orgId}&`;
    if (tenantId) url += `tenant_ids=${tenantId}&`;
    if (sourceTenantId) url += `source_tenant_id=${sourceTenantId}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
    if (orderId) url += `order_id=${orderId}&`;
    if (status) url += `status=${status}&`;
    if (customerId) url += `customer_id=${customerId}&`;
    if (excludeGRNCustomerIds) url += `customer_ids=${excludeGRNCustomerIds}&`;
    if (limit) url += `limit=${limit}&`;
    if (page) url += `page=${page}&`;
    if (fulfillmentStatus) url += `fulfillment_status=${fulfillmentStatus}&`;
    if (startDate) url += `from_date=${startDate}&`;
    if (endDate) url += `to_date=${endDate}&`;
    if (departmentId) url += `department_id=${departmentId}&`;
    if (listScreen) url += `list_screen=${listScreen}&`;
    if (paymentStatus) url += `payment_status=${paymentStatus}&`;
    if (secondaryStatus) url += `secondary_status=${secondaryStatus}&`;
    if (shopifySearchKeyword) url += `shopify_search_keyword=${shopifySearchKeyword}&`;
    if (tags) url += `tags=${tags}&`;
    if (accountManagerIds) url += `account_manager_ids=${accountManagerIds}&`;
    if (fromDeliveryDate) url += `from_delivery_date=${fromDeliveryDate}&`;
    if (toDeliveryDate) url += `to_delivery_date=${toDeliveryDate}&`;
    if (fromOrderDate) url += `from_order_date=${fromOrderDate}&`;
    if (toOrderDate) url += `to_order_date=${toOrderDate}&`;
    if (excludeOrderIds) url += `exclude_order_ids=${excludeOrderIds}&`;
    if (productSkuIds) url += `product_sku_ids=${productSkuIds}&`;
    if (isLinkedMrp) url += `is_linked_mrp=false&`;
    if (orderType) url += `order_type=${orderType}&`;
    const so = await Helpers.get({ url });
    return so;
  }


  updateFulfillmentLocation = async (payload) => {
    const updateFulfillmentLocation = await Helpers.put({
      url: Constants.UPDATE_FULFILLMENT_LOCATION,
      data: payload,
    });
    return updateFulfillmentLocation;
  }


  fulfillUnfulfilledOrder = async (payload) => {
    const fulfillUnfulfilledOrder = await Helpers.post({
      url: Constants.FULFILL_UF_FO,
      data: payload,
    });
    return fulfillUnfulfilledOrder;
  }


  createReturnFulfillment = async (payload) => {
    const createReturnFulfillment = await Helpers.post({
      url: Constants.CREATE_RETURN_FULFILLMENT,
      data: payload,
    });
    return createReturnFulfillment;
  }


  cancelReturnFulfillment = async (payload) => {
    const cancelReturnFulfillment = await Helpers.post({
      url: Constants.CANCEL_RETURN_FULFILLMENT,
      data: payload,
    });
    return cancelReturnFulfillment;
  }


  cancelFulfillment = async (payload) => {
    const cancelFulfillment = await Helpers.put({
      url: Constants.CANCEL_FULFILLMENT,
      data: payload,
    });
    return cancelFulfillment;
  }


  getReturnFulfillment = async (orderId) => {
    let url = `${Constants.GET_RETURN_FULFILLMENT}?`;
    if (orderId) url += `order_id=${orderId}&`;

    const so = await Helpers.get({ url });
    return so;
  }


  createRefund = async (payload) => {
    const createRefund = await Helpers.post({
      url: Constants.CREATE_REFUND,
      data: payload,
    });
    return createRefund;
  }


  getReturns = async (shopName, shopifyOrderId, orderId) => {
    let url = `${Constants.GET_RETURNS}?`;
    if (shopName) url += `shop_name=${shopName}&`;
    if (shopifyOrderId) url += `shopify_order_id=${shopifyOrderId}&`;
    if (orderId) url += `order_id=${orderId}&`;
    const so = await Helpers.get({ url });
    return so;
  }

  convertSoToMo = async (payload) => {
    const url = `${Constants.SO}/generate_mo?`;
    const so = await Helpers.post({
      url,
      data: payload,
    });
    return so;
  }

  getSoAvailability = async (soIds, tenantId, tenantDepartmentId, soLineIds, mrpId) => {
    let url = `${Constants.SO}/so_available_qty?`;
    if (soIds) url += `so_ids=${soIds}&`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (tenantId) url += `tenant_department_id=${tenantDepartmentId}&`;
    if (soLineIds) url += `so_line_ids=${soLineIds}&`;
    if (mrpId) url += `mrp_id=${mrpId}&`;
    const so = await Helpers.get({
      url,
    });
    return so;
  }
  // download SO List

  downloadSoList = async (payload) => {
    const list = await Helpers.post({
      url: Constants.DOWNLOAD_SO_LIST,
      data: payload,
    });
    return list;
  }

  // unlink SO and MO
  unlinkMOFromSo = async (payload) => {
    const unlink = await Helpers.delete({
      url: Constants.UNLINK_MO_SO,
      data: payload,
    });
    return unlink;
  }

  // quick update SO
  quickUpdateSO = async (payload) => {
    const so = await Helpers.put({
      url: `${Constants.SO}/quick`,
      data: payload,
    });
    return so;
  }
}
export default new SOServices();
